import { registry } from '@cian/mf-registry/browser';

export async function ensureHeaderMicrofrontend() {
  return registry().microfrontendStrict('header-frontend').api()?.ensure();
}
